import { useIsObserver } from '@platform/features/auth';
import { useMeQuery } from '@platform/state/api';
import { canQueryPii } from './canQueryPii';

/** Чи пропонувати сортування, фільтри й групування за полями з персональними даними в просторі `ws` (canQueryPii). */
export function useCanQueryPii(ws: string): boolean {
  const { data: me } = useMeQuery();
  return canQueryPii(me, ws, useIsObserver());
}
